import { render, staticRenderFns } from "./ReadyModal.vue?vue&type=template&id=2c823971&scoped=true&"
import script from "./ReadyModal.vue?vue&type=script&lang=js&"
export * from "./ReadyModal.vue?vue&type=script&lang=js&"
import style0 from "./ReadyModal.vue?vue&type=style&index=0&id=2c823971&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c823971",
  null
  
)

export default component.exports